var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { BaseCheckpointModel } from '../BaseCheckpointModel';
export class CourtCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
        this.fromJson(checkpoint);
    }
    fromJson(checkpoint) {
        this.courts = [];
        checkpoint.courts.forEach(element => {
            this.courts.push({
                courtId: element.courtId,
                name: element.name,
                researcherId: element.researcherId,
                comment: element.comment,
                verificationDate: element.verificationDate,
                requiresOralReconciliation: element.requiresOralReconciliation,
                showComment: element.comment != '',
                verified: element.verificationDate != null
            });
        });
        this.legalComment = checkpoint.legalComment;
        this.internalLegalComment = checkpoint.internalLegalComment;
    }
    toJson() {
        return {
            courts: this.courts,
            type: this.type,
            comment: this.comment,
            discrepancy: this.discrepancy,
            researcherId: this.researcherId,
            verificationDate: this.verificationDate,
            legalComment: this.legalComment,
            internalLegalComment: this.internalLegalComment
        };
    }
}
__decorate([
    observable
], CourtCheckpoint.prototype, "courts", void 0);
__decorate([
    observable
], CourtCheckpoint.prototype, "legalComment", void 0);
__decorate([
    observable
], CourtCheckpoint.prototype, "internalLegalComment", void 0);
__decorate([
    action
], CourtCheckpoint.prototype, "fromJson", null);
__decorate([
    action
], CourtCheckpoint.prototype, "toJson", null);
